import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import AccountService from "../services/account-service";
import { setShortCode } from "../duck/actions/organisation";
import { setUserData } from "../app/login/duck/actions/login";
import { useCacheActions } from "./useFetch";

/**
 * Handles the ?organisation=X query param set by OAuth callbacks and connect
 * flows. When detected, switches the active org in Redux, cleans the URL, and
 * refreshes the user's organisation list so the session reflects the change.
 */
function useOrganisationSwitchFromQuery({ user, isLoggedIn }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { invalidateEndpoint } = useCacheActions();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const newOrgShortCode = params.get("organisation");

    if (!newOrgShortCode || !isLoggedIn) return;

    dispatch(setShortCode(newOrgShortCode));

    // Keep the param on /addorganisation so the page can read it.
    if (location.pathname.startsWith("/addorganisation")) return;

    params.delete("organisation");
    const cleanedSearch = params.toString();
    history.replace(
      `${location.pathname}${cleanedSearch ? `?${cleanedSearch}` : ""}${location.hash || ""}`,
    );

    AccountService.getUserOrganisations().then((freshOrgs) => {
      dispatch(
        setUserData({
          ...user,
          organisations: freshOrgs,
          latestAccess: { organisation: newOrgShortCode },
        }),
      );

      invalidateEndpoint(AccountService.getUserOrganisations);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search, isLoggedIn]);
}

export default useOrganisationSwitchFromQuery;
